import React from "react";

import tinycolor from "tinycolor2";
import ReactApexChart from "react-apexcharts";

function EfficiencyPlayerRadial({ teamColor, series }) {
  // const series = [67];
  const options = {
    chart: {
      type: "radialBar",
      sparkline: {
        enabled: true,
      },
    },
    colors: [
      tinycolor.readability("#17171d", teamColor) <= 2
        ? tinycolor
            .mostReadable("#17171d", ["#00dd80", teamColor])
            .toHexString()
        : teamColor,
    ],
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: "50%",
        },
        track: {
          margin: 0,
          background: "#17171d",
        },
        dataLabels: {
          show: false,
        },
      },
    },
  };

  return (
    <>
      <ReactApexChart
        options={options}
        series={[series]}
        type="radialBar"
        height={55}
        width={55}
      />
    </>
  );
}

export default EfficiencyPlayerRadial;
